import * as Switch from "@radix-ui/react-switch";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils/cn";

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <Switch.Root
      checked={isDark}
      onCheckedChange={toggle}
      aria-label="Ubah tema gelap/terang"
      className={cn(
        "relative inline-flex h-7 w-12 shrink-0 items-center rounded-full border border-border bg-surface-2 transition-colors",
        isDark && "bg-accent/20",
      )}
    >
      <Switch.Thumb
        className={cn(
          "flex h-5 w-5 items-center justify-center rounded-full bg-accent text-accent-foreground shadow transition-transform duration-200",
          "translate-x-1 data-[state=checked]:translate-x-6",
        )}
      >
        {isDark ? <Moon className="h-3 w-3" /> : <Sun className="h-3 w-3" />}
      </Switch.Thumb>
    </Switch.Root>
  );
}
